var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datepicker',{attrs:{"highlighted":_vm.highlightedFn,"disabled-dates":_vm.disabledDates,"format":_vm.format,"language":_vm.languages['ptBR']},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})}
var staticRenderFns = []

export { render, staticRenderFns }